import axios from 'axios'
import load from '../utils/loading'
import 'es6-promise/auto'
axios.defaults.timeout = 30000
// 公共的数据请求接口
axios.defaults.baseURL = 'https://api.sanfengyun.com/'
axios.defaults.withCredentials = true

//封装动画耗时任务
function loadTask(){
	return new Promise(resolve => {setTimeout(()=>{load.remove();resolve()},200)})
}
// 添加请求拦截器
axios.interceptors.request.use(config => {
  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
	return config
} , error => Promise.reject(error))
// 添加响应拦截器
axios.interceptors.response.use(async function (response){
	return response
} , error => Promise.reject(error))
export default axios



// WEBPACK FOOTER //
// ./src/config/ajaxConfig.js